export default {"src":"/_next/static/media/mastercard.b4bc5258.svg","height":32,"width":49,"blurWidth":0,"blurHeight":0};